import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import Service from './reset.service'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import Form from './form.page'
import FormHelper from '../../../utils/FormHelper'
import { ScrollIntoViewById } from '../../../utils/UIHelper'
import iconLogo from '../../../assets/images/logo.png'

class Reset extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        document.title = "Setup password"
        ScrollIntoViewById("root")
    }

    handleTurnstileVerify = (token) => {
        this.setState({
            ...this.state,
            trunstileToken: token
        });
    };

    onSubmit = (e) => {
        e.preventDefault()
        this.service.isValid() && this.onReset()
    }

    onReset = () => {
        this.setState({
            ...this.state,
            verifying: true
        }, () => this.service.reset())
    }

    render() {
        return (
            <>
                {this.state.tab === 0 && <div className="login">
                    {this.state.processing && <Dialog><Loading /></Dialog>}
                    <header>
                        <img alt="" src={iconLogo} />
                        <h1>Reset your password</h1>
                        <p>Please enter your email address.</p>
                    </header>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <Form onSubmit={this.onSubmit} onChange={FormHelper(this).onChange} onRememberMeChange={this.onRememberMeChange} {...this.state} />
                    <div className="login-action">
                        Already have an account?
                        <Link to="/auth/login">Log In</Link>
                    </div>
                </div>}

                {this.state.tab === 1 && <div className="register">
                    <header>
                        <img alt="" src={iconLogo} />
                        <h1>Reset successful!</h1>
                        <p>Please <Link to="/auth/login">Log In</Link> to continue.</p>
                    </header>
                </div>}

            </>

        )
    }
}

export default withRouter(Reset)